<script setup lang="ts">
import { computed, ref } from 'vue'

import { useCdnImages } from '../../composables/use-cdn-images'
import { useConfigStore } from '../../stores/config'

const STORAGE_KEY = 'google-preferred-source-clicked'

const configStore = useConfigStore()
const { cdnImageUrl } = useCdnImages()

const brandName = computed(() => configStore.rsConfig.actualBrandName || '')
const sourceDomain = computed(() => configStore.rsConfig.googlePreferredSourceDomain || '')
const buttonUrl = computed(() => `https://www.google.com/preferences/source?q=${encodeURIComponent(sourceDomain.value)}`)

const visible = ref(import.meta.env.SSR || !localStorage.getItem(STORAGE_KEY))

function handleClick () {
  localStorage.setItem(STORAGE_KEY, '1')
  visible.value = false
}
</script>

<template>
  <div v-show="sourceDomain && visible"
       class="bx-content bx-google-preferred-source-button">
    <a :href="buttonUrl"
       target="_blank"
       rel="noopener noreferrer"
       @click="handleClick">
      <img :src="cdnImageUrl('/images/shared/google-logo.svg')"
           alt="Google Logo"
           aria-hidden="true"
           width="24"
           height="24">
      <span>{{ brandName }} bei Google bevorzugen</span>
    </a>
  </div>
</template>
